export const ticketOpenColumns = [
    { field: "id", headerName: "Ticket ID", width: 150 },
    {
        field: "created_at",
        headerName: "Submit Date",
        width: 180,
        renderCell: (params) => {
            const date = new Date(params.value); // Convert miliseconds to Date
            return new Intl.DateTimeFormat("id-ID", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            }).format(date);
        },
    },
    {
        field: "user_id",
        headerName: "User ID",
        width: 150,
    },  {
        field: "month",
        headerName: "Months",
        width: 100,
    },
    {
        field: "year",
        headerName: "Years",
        width: 100,
    },
    {
        field: "region_id",
        headerName: "Region ID",
        width: 100,
    },
    {
        field: "segment_customer",
        headerName: "Segment Customer",
        width: 230,
    },
    {
        field: "status_id",
        headerName: "Status",
        width: 160,
        renderCell: (params) => {
            return (
                <div className={`cellWithStatus ${params.row.status_id}`}>
                    {params.row.status_id}
                </div>
            );
        },
    },
    {
        field: "category_id",
        headerName: "Category",
        width: 230,
    },
];

//temporary data
export const ticketOpenRows = [
    {
        id: 1143155,
        number_ticket: 785,
        customerId: "Flynet",
        img: "https://m.media-amazon.com/images/I/81bc8mA3nKL._AC_UY327_FMwebp_QL65_.jpg",
        down_time : "232323",
        segmentCustomer: "John Smith",
        created_at: 1723109131795,
        method: "Cash on Delivery",
        status: "Ongoing",
    },
    {
        id: 2235235,
        customerId: "Siap NET",
        img: "https://m.media-amazon.com/images/I/31JaiPXYI8L._AC_UY327_FMwebp_QL65_.jpg",
        segmentCustomer: "Michael Doe",
        down_time : "232323",
        created_at: 1723109131795,
        amount: 900,
        method: "Online Payment",
        status_id: "Pending",
    },
    {
        id: 2342353,
        customerId: "NUSANET",
        img: "https://m.media-amazon.com/images/I/71kr3WAj1FL._AC_UY327_FMwebp_QL65_.jpg",
        segmentCustomer: "John Smith",
        down_time : "232323",
        created_at: 1723109131795,
        amount: 35,
        method: "Cash on Delivery",
        status: "Pending",
    },
    {
        id: 2357741,
        customerId: "NANANG Racing",
        img: "https://m.media-amazon.com/images/I/71wF7YDIQkL._AC_UY327_FMwebp_QL65_.jpg",
        segmentCustomer: "Jane Smith",
        down_time : "232323",
        created_at: 1723109131795,
        amount: 920,
        method: "Online",
        status: "Closed",
    },
    {
        id: 2342355,
        customerId: "DAFFA",
        img: "https://m.media-amazon.com/images/I/81hH5vK-MCL._AC_UY327_FMwebp_QL65_.jpg",
        segmentCustomer: "Harold Carol",
        created_at: 1723109131795,
        amount: 2000,
        method: "Online",
        status: "Pending",
    },
    {
        id: 1321535,
        customerId: "TRY",
        img: "https://m.media-amazon.com/images/I/81hH5vK-MCL._AC_UY327_FMwebp_QL65_.jpg",
        segmentCustomer: "Harold Carol",
        created_at: 1723109131795,
        status_id: "OPEN",
        updated_at: 1723109131795,
        status: "Open",
    },
    {
        id: 132155,
        customerId: "AZMI",
        img: "https://m.media-amazon.com/images/I/81hH5vK-MCL._AC_UY327_FMwebp_QL65_.jpg",
        segmentCustomer: "Harold Carol",
        created_at: 1723109131795,
        amount: 2000,
        method: "Online",
        status: "Solved",
    },
];
